"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumStringKeys = enumStringKeys;
exports.enumNumericValues = enumNumericValues;
exports.buildStringEnumValidator = buildStringEnumValidator;
/**
 * Given an enum object, returns a collection of string based keys. This can be
 * used to get all keys of an enum object without having to filter the inverse
 * id number key entries.
 * @param obj Enum object to iterate.
 * @returns Collection of string keys.
 */
function enumStringKeys(obj) {
    return Object.keys(obj).filter((k) => Number.isNaN(Number(k)));
}
/**
 * Given an enum object, returns a collection of numeric-only values.
 * @param obj Enum object to iterate.
 * @returns Collection of numeric values.
 */
function enumNumericValues(obj) {
    return Object.values(obj).filter((k) => !Number.isNaN(Number(k)));
}
/**
 * Given an enum object, returns a function that can validate if a given string
 * is a valid value for the originating enum.
 * @param enumObj The string enum to create the validator for.
 * @returns A method `(value: string): value is T`, returning `true` if `value` is a valid
 * value of `T` enum, otherwise `false`.
 */
function buildStringEnumValidator(enumObj) {
    const values = Object.values(enumObj);
    return (value) => values.includes(value);
}
//# sourceMappingURL=lib.js.map